module.exports = __webpack_public_path__ + "static/img/1-0.dea68af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/pressCenter/1-0.png
// module id = tNYc
// module chunks = 15